import { render } from "./BaseStoreHeader.vue?vue&type=template&id=7686cda6"
import script from "./BaseStoreHeader.vue?vue&type=script&lang=js"
export * from "./BaseStoreHeader.vue?vue&type=script&lang=js"

import "./BaseStoreHeader.vue?vue&type=style&index=0&id=7686cda6&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__